// extracted by mini-css-extract-plugin
export var measureBox = "_bv-0";